import { Subject } from 'rxjs';
import axios from 'axios';
import { Gizmo } from '../../gizmos';
import { IGizmoData } from '../../types';
import CommonBinder from '../common-binder';
import clone from 'clone';

interface IChartBinder {
  init(): Promise<void>;
}

interface IChartDataPoint {
  x: number | string;
  y: number;
}

class ChartBinder extends CommonBinder implements IChartBinder {
  public data: Subject<IChartDataPoint[]>;

  constructor(gizmo: Gizmo) {
    super(gizmo);

    this.data = new Subject<IChartDataPoint[]>();
    this._gizmo.data.subscribe(
      (data: IGizmoData | IGizmoData[] | undefined) => {
        if (data && !Array.isArray(data) && data.cd) {
          this.data.next(data.cd);
        }
      }
    );
  }

  public init = (): Promise<void> => {
    return new Promise<void>(async resolve => {
      if (!this._gizmo.getData()) {
        await this._getDataFromServer();
      }
      resolve();
    });
  };

  /**
   * Get data that will be plotted in the chart
   *
   * @returns {IChartDataPoint[]}
   */
  public getData = (): IChartDataPoint[] => {
    const data = this._gizmo.getData() as IGizmoData;

    if (data?.cd) {
      return data.cd;
    }

    return [];
  };

  private _getDataFromServer = (): Promise<void> => {
    return new Promise<void>(async resolve => {
      const apiUrl: string | undefined = this._gizmo.getDao()?.getApiUrl();

      if (apiUrl) {
        const config = clone(this._gizmo.getConfig());
        const params = this._gizmo.getParams();

        if (
          config.ops?.chart?.paramRootGizmoFid &&
          params &&
          params[config.ops.chart.paramRootGizmoFid]
        ) {
          config.ops = {
            chart: {
              type: config.ops.chart.type,
              rootGizmoFid: params[config.ops.chart.paramRootGizmoFid],
            },
          };
        } else if (
          !config.ops?.chart?.rootGizmoFid &&
          params &&
          params['fid']
        ) {
          config.ops = {
            chart: {
              type: config.ops?.chart?.type || 'bar',
              rootGizmoFid: params['fid'],
            },
          };
        }


        if (config.ops?.chart?.rootGizmoFid) {
          const url = `${apiUrl}/charts_api/v1/charts/data`;

          const response = await axios({
            method: 'POST',
            url,
            data: {
              gizmo: config,
            },
          });

          if (response.status === 200) {
            const { data } = response;
            this._gizmo.setData(data);
          }
        }
      }
      resolve();
    });
  };
}

export default ChartBinder;
